import type { QualityPreset, SnapshotFormat } from '@/types';

export const GUEST_DAILY_LIMIT = 3;
/** Signed-in users: a high daily cap that's effectively unlimited for real
 *  users but blocks scripted abuse (and runaway Blaze-plan cost). */
export const USER_DAILY_LIMIT = 200;
export const FILE_TTL_HOURS = 24;

export const SNAPSHOT_INTERVALS = [1, 3, 5] as const;
export const MIN_SNAPSHOT_INTERVAL = 1;
export const MAX_SNAPSHOT_INTERVAL = 30;

export const SNAPSHOT_FORMATS: { value: SnapshotFormat; label: string }[] = [
  { value: 'jpg', label: 'JPG' },
  { value: 'png', label: 'PNG' },
];

export interface QualityOption {
  value: QualityPreset;
  label: string;
  height: number;
}

export const QUALITY_OPTIONS: QualityOption[] = [
  { value: 'best', label: 'Best available', height: 1080 },
  { value: '1080p', label: '1080p · Full HD', height: 1080 },
  { value: '720p', label: '720p · HD', height: 720 },
  { value: '480p', label: '480p · SD', height: 480 },
];

export const AUDIO_BITRATE_KBPS = 192;
